<template>
    <div class="submenu_permission">
        <div class="background-shapes">
            <div class="shape triangle-1"></div>
            <div class="shape triangle-2"></div>
            <div class="shape circle"></div>
        </div>
        <div class="row menu-form">
            <div class="col-12 mb-3">
                <b-card class="rounded-2 text-white bg-primary shadow-lg">
                    <h3 class="mb-0">{{$t("Create New Blog Post")}}</h3>
                </b-card>
            </div>
            <div class="col-md-3 mb-3">
                <b-button @click="showModal = true" class="btn btn-info btn-sm text-white">Category Add +</b-button>
            </div>
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
                <div class="col-12">
                    <b-card class="p-3">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <b-form-group label="Title" label-for="title" class="text-uppercase">
                                    <b-form-input
                                            id="title"
                                            v-model="formData.contentTitle"
                                            placeholder="Enter blog title"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6 mb-3">
                                <b-form-group label="Author" label-for="author" class="text-uppercase">
                                    <b-form-input
                                            id="author"
                                            v-model="formData.authorName"
                                            placeholder="Author name"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6 mb-3">
                                <b-form-group label="Category" label-for="author" class="text-uppercase">
                                    <b-form-select
                                            id="author"
                                            v-model="formData.categoryId"
                                            :options="categoriesData"
                                            placeholder="Author name"
                                            text-field="category"
                                            value-field="requestKey"
                                            required
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 mb-3">
                                <b-form-group label="Order No" label-for="order_no" class="text-uppercase">
                                    <b-form-input
                                            id="author"
                                            v-model="formData.orderBy"
                                            placeholder="Order No"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 mb-3">
                                <b-form-group label="Reference" label-for="reference"
                                              class="text-uppercase ">
                                    <b-form-input
                                            id="reference"
                                            v-model="formData.reference"
                                            placeholder="Reference"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group
                                        label="Feature Image"
                                        label-for="feature-image"
                                        class="feature-image"
                                >
                                    <input
                                            type="file"
                                            ref="fileinput"
                                            name="featureImage"
                                            @change="attachmentSend"
                                            class="form-control form-control-md"
                                    />
                                    <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
                                </b-form-group>
                            </div>

                            <div class="col-md-8 mb-3">
                                <b-form-group label="Content English" label-for="editor"
                                              class="">
                                    <QuillEditor
                                            ref="plainContentEnEditor"
                                            v-model="formData.plainContentEn"
                                            content-type="html"
                                            theme="snow"
                                            placeholder="Write your Plain content here..."
                                            style="min-height: 250px"
                                            :toolbar="toolbarOptions"
                                            @ready="onEditorReady"
                                    />
                                </b-form-group>
                            </div>
                            <div class="col-md-8 mb-3">
                                <b-form-group label="Content Bangla" label-for="content"
                                              class="">
                                    <QuillEditor
                                            ref="plainContentBnEditor"
                                            v-model="formData.plainContentBn"
                                            content-type="html"
                                            theme="snow"
                                            placeholder="Write your Plain content here..."
                                            style="min-height: 250px"
                                            :toolbar="toolbarOptions"
                                            @ready="onEditorReady"
                                    />
                                </b-form-group>
                            </div>
                            <div class="col-md-8 mb-3">
                                <b-form-group label="Summary" label-for="content"
                                              class="">
                                    <b-form-textarea
                                            v-model="formData.summary"
                                            content-type="html"
                                            theme="snow"
                                            placeholder="Write your summery here..."
                                            style="min-height: 100px"
                                    ></b-form-textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-8 text-success">
                                <b-form-group
                                        label="Status"
                                        v-slot="{ ariaDescribedby }"
                                        label-for="radios-btn-default" class="">

                                    <b-form-radio-group
                                            id="btn-radios-1"
                                            v-model="formData.activeYn"
                                            :options="optionsStatus"
                                            :aria-describedby="ariaDescribedby"
                                            :button-variant="(formData.activeYn=='N')?'outline-danger':'outline-success'"
                                            name="active_status"
                                            buttons
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>

                            <div class="col-12 d-flex flex-column flex-md-row justify-content-end gap-2 mt-3">
                                <b-button type="submit" class="btn btn-info text-white">Publish</b-button>
                                <b-button type="reset" variant="outline-danger">Clear</b-button>
                            </div>

                        </div>
                    </b-card>
                </div>
            </b-form>
            <div class="card p-4 mt-4">
                <h5 class="bg-success p-3 rounded text-white fw-bold text-uppercase">Blog Post List</h5>

                <div class="card-body mt-4 col-12" v-if="fetchBlogData.length > 0">
                    <!-- Responsive Table Wrapper -->
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th v-for="(header, index) in headers" :key="index">
                                    {{ header.text }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in paginatedItems" :key="item.requestKey">
                                <td v-for="(header, hIndex) in headers" :key="hIndex" class="text-start">

                                    <template v-if="header.value === 'activeYn'">
                                        <span>{{ item.activeYn === 'Y' ? 'Active' : 'Inactive' }}</span>
                                    </template>

                                    <template v-else-if="header.value === 'action2'">
                                        <a class="btn text-dark" @click="editBlogPost(item)">
                                            <font-awesome-icon icon="pen-to-square"/>
                                        </a>
                                    </template>

                                    <template v-else-if="['summary', 'ContentEn', 'ContentBn'].includes(header.value)">
                                          <span>
                                            {{ item[header.value] ? item[header.value].slice(0, 150) + (item[header.value].length > 150 ? '...' : '') : '' }}
                                          </span>
                                    </template>

                                    <template v-else>
                                        <span>{{ item[header.value] }}</span>
                                    </template>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination Controls (MOVED OUTSIDE <tbody>) -->
                    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3 gap-2">
                        <b-button class="btn btn-outline-success" :disabled="currentPage === 1" @click="currentPage--">
                            Previous
                        </b-button>
                        <span>Page {{ currentPage }} of {{ totalPages }}</span>
                        <b-button class="btn btn-outline-success" :disabled="currentPage === totalPages"
                                  @click="currentPage++">
                            Next
                        </b-button>
                    </div>
                </div>

                <div class="border text-center p-3" v-else>
                    Data Not Found !!
                </div>
            </div>

        </div>

    </div>


    <div v-if="showModal" class="modal-overlay" @click="closeModal">
        <div class="modal-content modal-lg" @click.stop>
            <div class="modal-header">
                <h5>Add Category</h5>
                <button @click="closeModal" class="close-btn">&times;</button>
            </div>

            <div class="modal-body">
                <!-- Form Section -->
                <div class="row mb-4">
                    <b-col sm="6">
                        <b-form-group label="Category Name" label-for="category-name">
                            <b-form-input
                                    v-model="categoryData.categoryNameEn"
                                    type="text"
                                    placeholder="Category Name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Category Name Bangla">
                            <b-form-input
                                    v-model="categoryData.categoryNameBn"
                                    type="text"
                                    placeholder="Category Name Bangla"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group
                                label="Status"
                                v-slot="{ ariaDescribedby }"
                                label-for="radios-btn-default"
                        >
                            <b-form-radio-group
                                    id="activeYn"
                                    v-model="categoryData.activeYn"
                                    :options="categoryStatus"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="(categoryData.activeYn=='N')?'outline-danger':'outline-success'"
                                    name="activeYn"
                                    buttons
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" class="text-end mt-5">
                        <b-button
                                @click="categoryAdd()"
                                class="btn btn-success"
                        >
                            {{ isEdit ? 'Update' : 'Add' }}
                        </b-button>
                    </b-col>
                </div>

                <hr>

                <!-- Table Section -->
                <div class="table-section">
                    <h6 class="mb-3">Categories List</h6>
                    <b-table
                            :items="allCategoriesData"
                            :fields="fields"
                            striped
                            hover
                            responsive
                            show-empty
                            empty-text="No categories found"
                            :busy="isLoading"
                            small
                    >
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>

                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>

                        <template #cell(activeYn)="data">
                            <b-badge :variant="data.item.activeYn === 'Y' ? 'success' : 'danger'">
                                {{ data.item.activeYn === 'Y' ? 'Active' : 'Inactive' }}
                            </b-badge>
                        </template>

                        <template #cell(actions)="data">
                            <b-button
                                    size="sm"
                                    variant="info"
                                    class="mr-1"
                                    @click="editCategory(data.item)"
                            >
                                <i class="fa fa-edit">Edit</i>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="modal-footer">
                <button @click="closeModal" class="cancel-btn">Close</button>
            </div>
        </div>
    </div>
    <!--<div v-if="showModal" class="modal-overlay" @click="showModal = false">
        <div class="modal-content" @click.stop>
            <div class="modal-header" size="lg">
                <h5>Add Category</h5>
                <button @click="showModal = false" class="close-btn">&times;</button>
            </div>

            <div class="modal-body row">
                <b-col sm="6">
                    <b-form-group label="Category Name" label-for="category-name">
                        <b-form-input
                                v-model="categoryData.categoryNameEn"
                                type="text"
                                class=""
                                placeholder="Category Name"
                        >

                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Category Name Bangla">
                        <b-form-input
                                v-model="categoryData.categoryNameBn"
                                type="text"
                                class=""
                                placeholder="Category Name Bangla"
                        >

                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group
                            label="Status"
                            v-slot="{ ariaDescribedby }"
                            label-for="radios-btn-default" class="">

                        <b-form-radio-group
                                id="activeYn"
                                v-model="categoryData.activeYn"
                                :options="categoryStatus"
                                :aria-describedby="ariaDescribedby"
                                :button-variant="(categoryData.activeYn=='N')?'outline-danger':'outline-success'"
                                name="activeYn"
                                buttons
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
            </div>

            <div class="modal-footer">
                <button @click="showModal = false" class="cancel-btn">Cancel</button>
                <button @click="categoryAdd" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>-->
</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import {QuillEditor} from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'
    import {toast} from 'vue3-toastify'

    export default {
        name: 'blogPost',
        components: {
            QuillEditor
        },
        data() {
            return {
                isEdit: false,
                isLoading: false,
                formData: {
                    blogId: "",
                    contentTitle: "",
                    authorName: "",
                    reference: "",
                    image: "",
                    contentEn: "",
                    contentBn: "",
                    plainContentEn: "",
                    plainContentBn: "",
                    summary: "",
                    activeYn: "Y",
                    orderBy: "",
                    categoryId: null
                },
                toolbarOptions: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{'header': 1}, {'header': 2}],               // custom button values
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                    [{'direction': 'rtl'}],                         // text direction

                    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                    [{'header': [1, 2, 3, 4, 5, 6, false]}],

                    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                    [{'font': []}],
                    [{'align': []}],

                    ['link', 'image'],                       // Add image button here

                    ['clean']                                         // remove formatting button
                ],
                categoryData: {
                    requestKey: null,
                    categoryNameEn: '',
                    categoryNameBn: '',
                    activeYn: 'Y'
                },
                fields: [
                    {key: 'index', label: 'SL'},
                    {key: 'categoryNameEn', label: 'Category Name'},
                    {key: 'categoryNameBn', label: 'Category Name (Bangla)'},
                    {key: 'activeYn', label: 'Status', class: 'text-center'},
                    {key: 'actions', label: 'Actions', class: 'text-center'}
                ],
                categoriesData: [
                    {text: 'categoryNameEn', value: 'requestKey'},
                ],
                headers: [
                    {text: 'SL', value: 'orderBy'},
                    {text: 'Title', value: 'contentTitle'},
                    {text: 'Author Name', value: 'authorName'},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Summary', value: 'summary'},
                    {text: 'Content English', value: 'ContentEn'},
                    {text: 'Content Bangla', value: 'ContentBn'},
                    {text: 'Active Yn', value: 'activeYn'},
                    {text: 'Action', value: 'action2'},
                ],
                currentPage: 1,
                perPage: 5,
                categoryOptions: [],
                allCategoriesData: [],
                fetchBlogData: [],
                optionsStatus: [
                    {text: 'Active', value: 'Y'},
                    {text: 'Inactive', value: 'N'},
                ],
                categoryStatus: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'},
                ],
                showModal: false,
            }

        },
        computed: {
            totalPages() {
                return Math.ceil(this.fetchBlogData.length / this.perPage);
            },
            paginatedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.fetchBlogData.slice(start, end);
            }
        },
        mounted() {
            this.getBlogPostData();
            this.getCategoriesData();
            this.allCategoryData();
        },
        methods: {

            onSubmit() {
                const quillEn = this.$refs.plainContentEnEditor.getQuill();
                const quillBn = this.$refs.plainContentBnEditor.getQuill();
                this.formData.contentEn = quillEn.getText().trim();
                this.formData.contentBn = quillBn.getText().trim();
                this.formData.plainContentEn = this.$refs.plainContentEnEditor.getHTML();
                this.formData.plainContentBn = this.$refs.plainContentBnEditor.getHTML();

                apiRepository.blogPost(this.formData).then((res) => {
                    if (res) {
                        toast.success(res.data)
                        this.allCategoryData();
                        this.onReset();
                    }
                }).catch((error) => {
                    toast.error(error.data.message);
                });
            },
            editBlogPost(item) {
                console.log('item', item)
                this.formData = {
                    ...item,
                    blogId: item.requestKey
                };
                this.$nextTick(() => {
                    if (this.$refs.plainContentEnEditor) {
                        this.$refs.plainContentEnEditor.setHTML(item.plainContentEn || '');
                    }

                    if (this.$refs.plainContentBnEditor) {
                        this.$refs.plainContentBnEditor.setHTML(item.plainContentBn || '');
                    }
                });
            },
            getBlogPostData() {
                apiRepository.getBlogPost().then((res) => {
                    this.fetchBlogData = res.data;
                }).catch((error) => {
                    console.error(error.response);
                })
            },

            motherNidAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.parentInfo.motherNIDFile = reader.result;
                    };
                }
            },
            attachmentSend(event) {
                const file = event.target.files[0];
                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.formData.image = reader.result;
                    };
                }
            },
            /*categoryAdd() {
                this.showModal = true;
                apiRepository.categoryAdd(this.categoryData).then((res) => {
                    if (res) {
                        toast.success(res.data);
                        this.onReset();
                    }
                })
                    .catch((error) => {
                        const message =
                            error?.response?.data?.message ||
                            error?.response?.data ||
                            "Something went wrong!";
                        toast.error(message);
                    });
            },*/
            openAddModal() {
                this.isEdit = false;
                this.onReset();
                this.showModal = true;
            },

            closeModal() {
                this.showModal = false;
                this.onReset();
                this.categoryData = {}
            },

            categoryAdd() {
                apiRepository.categoryAdd(this.categoryData)
                    .then((res) => {
                        if (res) {
                            toast.success(res.data.message || 'Category added successfully!');
                            this.allCategoryData();
                            this.resetModal();
                        }
                    })
                    .catch((error) => {
                        const message =
                            error?.response?.data?.message ||
                            error?.response?.data ||
                            "Something went wrong!";
                        toast.error(message);
                    });
            },

            editCategory(item) {
                this.isEdit = true;
                this.categoryData = {
                    categoryNameEn : item.categoryNameEn,
                    categoryNameBn : item.categoryNameBn,
                    requestKey : item.requestKey,
                    activeYn : item.activeYn
                };
                this.showModal = true;
            },


            getCategoriesData() {
                apiRepository.getCategoryData().then((res) => {
                    if (res) {
                        // toast.success(res.data)
                        this.categoriesData = res.data;
                    }
                }).catch((error) => {
                    toast.error(error.data.message);
                });
            },
            allCategoryData() {
                apiRepository.getAllCategoryData().then((res) => {
                    if (res) {
                        // toast.success(res.data)
                        this.allCategoriesData = res.data;
                    }
                }).catch((error) => {
                    toast.error(error.data.message);
                });
            },
            resetModal() {
                this.categoryData = {}
            },
            onReset() {
                this.formData = {
                    blogId: "",
                    contentTitle: "",
                    authorName: "",
                    reference: "",
                    image: "",
                    contentEn: null,
                    contentBn: null,
                    plainContentEn: null,
                    plainContentBn: null,
                    summary: null,
                    activeYn: "Y",
                    orderBy: ""
                };
                this.$nextTick(() => {
                    if (this.$refs.plainContentEnEditor) {
                        const quillEn = this.$refs.plainContentEnEditor.getQuill()
                        quillEn.setContents([]) // clear all content
                        quillEn.history.clear() // clear undo/redo history
                    }
                    if (this.$refs.plainContentBnEditor) {
                        const quillBn = this.$refs.plainContentBnEditor.getQuill()
                        quillBn.setContents([])
                        quillBn.history.clear()
                    }
                })
            },
            onEditorReady(editor) {
                // ✅ THE ONLY FIX NEEDED: Patch setNativeRange to clamp offsets safely
                // This fixes the "offset X is larger than node's length" crash at the source
                const selection = editor.selection
                const _setNativeRange = selection.setNativeRange.bind(selection)

                selection.setNativeRange = function (startNode, startOffset, endNode, endOffset, force) {
                    try {
                        // Clamp text node offsets to their actual length before browser call
                        if (startNode?.nodeType === Node.TEXT_NODE) {
                            startOffset = Math.min(startOffset ?? 0, startNode.length)
                        }
                        if (endNode?.nodeType === Node.TEXT_NODE) {
                            endOffset = Math.min(endOffset ?? 0, endNode.length)
                        }
                        _setNativeRange(startNode, startOffset, endNode, endOffset, force)
                    } catch (err) {
                        // Silently absorb any remaining edge cases
                    }
                }

                // ✅ HTML paste — preserve full formatting
                editor.root.addEventListener('paste', (e) => {
                    e.preventDefault()
                    const clipboardData = e.clipboardData || window.clipboardData
                    const html = clipboardData.getData('text/html')
                    const plain = clipboardData.getData('text/plain')

                    const range = editor.getSelection()
                    const length = editor.getLength()
                    const safeIndex = (range?.index != null)
                        ? Math.min(range.index, Math.max(0, length - 1))
                        : Math.max(0, length - 1)

                    if (html) {
                        editor.clipboard.dangerouslyPasteHTML(safeIndex, html, 'user')
                    } else if (plain) {
                        editor.insertText(safeIndex, plain, 'user')
                    }

                    // Move cursor to end of editor after paste
                    setTimeout(() => {
                        const newLength = editor.getLength()
                        editor.setSelection(Math.max(0, newLength - 1), 0, 'silent')
                    }, 20)
                })

                // ✅ DO NOT override Enter or Shift+Enter at all
                // Quill handles newlines perfectly on its own once setNativeRange is safe
            }

        }
    }
</script>

<style scoped>
    /*background style*/
    .submenu_permission {
        position: relative;
        padding: 2rem;
        background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
        border-radius: 15px;
        overflow: hidden;
    }

    .background-shapes {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .shape {
        position: absolute;
        background: rgba(255, 255, 255, 0.3);
    }

    .triangle-1 {
        width: 0;
        height: 0;
        border-left: 100px solid transparent;
        border-right: 100px solid transparent;
        border-bottom: 200px solid rgba(255, 99, 71, 0.3);
        top: -50px;
        left: -50px;
        transform: rotate(45deg);
    }

    .triangle-2 {
        width: 0;
        height: 0;
        border-left: 80px solid transparent;
        border-right: 80px solid transparent;
        border-bottom: 160px solid rgba(70, 130, 180, 0.3);
        bottom: -80px;
        right: -80px;
        transform: rotate(-30deg);
    }

    .circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(144, 238, 144, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .menu-form {
        position: relative;
        z-index: 2;
        /*background: rgba(255, 255, 255, 0.9);*/
        padding: 1px;
        border-radius: 10px;
        /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
        animation: fadeIn 0.5s ease-in-out;
    }

    .ctg-add-btn {
        padding: 8px 16px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

    .ctg-add-btn:hover {
        background-color: #45a049;
    }


    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999; /* Increased z-index */
        overflow-y: auto; /* Allow scrolling if content is too tall */
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        position: relative; /* Add this */
        margin: 20px; /* Add margin for spacing */
    }

    .modal-lg {
        max-width: 900px;
        width: 90%;
        max-height: 90vh; /* Limit height */
        display: flex;
        flex-direction: column;
    }

    .modal-header {
        padding: 15px 20px;
        border-bottom: 1px solid #dee2e6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgb(7, 119, 71);
        flex-shrink: 0; /* Prevent shrinking */
    }

    .modal-header h5 {
        margin: 0;
        font-size: 1.25rem;
        font-weight: 600;
    }

    .close-btn {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: #000;
        padding: 0;
        width: 30px;
        height: 30px;
        line-height: 1;
    }

    .close-btn:hover {
        color: #dc3545;
    }

    .modal-body {
        padding: 20px;
        overflow-y: auto; /* Scrollable body */
        flex: 1; /* Take available space */
    }

    .table-section {
        margin-top: 20px;
    }

    .modal-footer {
        padding: 15px 20px;
        border-top: 1px solid #dee2e6;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        background-color: #f8f9fa;
        flex-shrink: 0; /* Prevent shrinking */
    }

    .cancel-btn {
        padding: 8px 20px;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        font-weight: 500;
        background-color: #6c757d;
        color: white;
    }

    .cancel-btn:hover {
        background-color: #5a6268;
    }
</style>